@if (customerServiceSection$ | async; as customerServiceSection) { @if (!isMobile) {
<div class="customer-service-section" (clickOutside)="refreshSelectedClass()">
  <h2>{{ customerServiceSection.title }}</h2>
  @if (customerServiceSectionData$ | async; as customerServiceSectionData) {
  <mat-nav-list>
    @for (link of customerServiceSectionData; track link.uid; let i = $index) {
    <a
      mat-list-item
      disableRipple
      [class.selected]="customerServiceSectionActive === link.uid"
      (click)="onClickCustomerServiceSectionLink(link, i); activeI = i"
    >
      {{ link.title ? link.title : link.linkName }}
    </a>
    }
  </mat-nav-list>
  }
</div>
} }
